import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/lib/trpc'

export function useCustomers() {
  const trpc = useTRPC()
  return useQuery(trpc.customers.list.queryOptions())
}

export function useCreateCustomer() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.customers.create.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpc.customers.list.pathFilter())
    })
  )
}

export function useUpdateCustomer() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.customers.update.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpc.customers.list.pathFilter())
    })
  )
}
